<template>
    <header :class="['app-header', {fixed: isFixed && !isMobileMenu, 'fixed02': isFixed && isMobileMenu, sp: isMobileMenu}]">
        <router-link to="/" class="pl-2">
            <img v-if="$route.name === 'home' && !isFixed" class="logo pc" src="./images/logo.png" alt="AUBE">
            <img v-if="$route.name !== 'home' && !isFixed" class="logo pc" src="./images/logo_04.png" alt="AUBE">
            <img v-if="isFixed" class="logo pc" src="./images/logo_01.png" alt="AUBE">
            <img class="logo sp topLayer" src="./images/logo_01.png" alt="AUBE">
        </router-link>
        <!-- {{ $route.name }} -->
        <div v-if="isMobileMenu">
            <div :class="{ 'member-info-mobile': isScrolled }">
                <MemberInfo
                    :isLogged="isLogged"
                    :memberType="memberType"
                    :memberTypeId="memberTypeId"
                    :forceClubId="forceClubId"
                    :questId="questId"
                    :aubeId="aubeId"
                    :isLoading="isLoading"
                    :themeTextColor="headerTextColor"
                />
            </div>
            <transition name="animateMenu">
                <div v-if="isOpenMenu" class="right mobile-menu">
                    <ul>
                        <li class="home" v-if="!isLogged">
                            <router-link @click.native="handleOnClickCloseMenu()" to="/">{{ $t('menu.top') }}</router-link>
                        </li>
                        <li v-if="!isLogged" class="guide">
                            <router-link @click.native="handleOnClickCloseMenu()"  to="/guide">{{ $t('menu.guide') }}</router-link>
                        </li>
                        <li v-if="isLogged" class="video">
                            <router-link @click.native="handleOnClickCloseMenu()"  to="/studies-top">{{ $t('menu.video') }}</router-link>
                        </li>
                        <li v-if="isLogged && !isChild" class="setting">
                            <router-link @click.native="handleOnClickCloseMenu()"  to="/settings">{{ $t('menu.settings') }}</router-link>
                        </li>
                        <ol class="menu02 sp">
                            <li v-if="isLogged">
                                <span>{{ $t('menu.member_type') }}{{ $t('member_type.' + memberType) }}</span>
                            </li>
                            <li v-if="isLogged">
                                <span>AUBE ID: {{ aubeId }}</span>
                            </li>
                            <li v-if="isAdvanceMember() && isLogged">
                                <span>ForceClub ID: {{ forceClubId }}</span>
                            </li>
                            <li v-if="(isAdvanceMember() || isProgressMember()) && isLogged">
                                <span>Quest ID: {{ questId }}</span>
                            </li>
                            <li>
                                <router-link @click.native="handleOnClickCloseMenu()" to="/faq">{{ $t('menu.faq') }}</router-link>
                            </li>
                            <li>
                                <router-link @click.native="handleOnClickCloseMenu()" to="/terms">{{ $t('menu.terms') }}</router-link>
                            </li>
                            <li>
                                <router-link @click.native="handleOnClickCloseMenu()" to="/policy">{{ $t('menu.policy') }}</router-link>
                            </li>
                            <li>
                                <router-link @click.native="handleOnClickCloseMenu()" to="/tokushoho">{{ $t('menu.tokushoho') }}</router-link>
                            </li>
                            <li>
                                <router-link @click.native="handleOnClickCloseMenu()" to="/company">{{ $t('menu.operating') }}</router-link>
                            </li>
                        </ol>
                    </ul>
                    <div v-if="!isLogged" class="log sp">
                        <!--
                        <div>
                            <router-link @click.native="handleOnClickCloseMenu()" to="/registration-new" class="icon"><span id="register-sp"></span>{{ $t('auth.register') }}</router-link>
                        </div>
                        -->
                        <div>
                            <router-link @click.native="handleOnClickCloseMenu()" to="/login" class="icon"><span></span>{{ $t('auth.login') }}</router-link>
                        </div>
                    </div>
                    <div v-else class="log out sp">
                        <router-link to="/" class="icon" @click.native="handleOnClickLogout()"><span></span>{{ $t('auth.logout') }}</router-link >
                    </div>
                </div>
            </transition>
        </div>
        <div v-else class="right">
            <div>
                <MemberInfo
                    :isLogged="isLogged"
                    :memberType="memberType"
                    :memberTypeId="memberTypeId"
                    :forceClubId="forceClubId"
                    :questId="questId"
                    :aubeId="aubeId"
                    :isLoading="isLoading"
                    :themeTextColor="headerTextColor"
                />

                <ul>
                    <li class="home" v-if="!isLogged">
                        <router-link to="/">{{ $t('menu.top') }}</router-link>
                    </li>
                    <li v-if="!isLogged" class="guide">
                        <router-link @click.native="handleOnClickCloseMenu()"  to="/guide">{{ $t('menu.guide') }}</router-link>
                    </li>

                    <li v-if="isLogged" class="video">
                        <router-link to="/studies-top">{{ $t('menu.video') }}</router-link>
                    </li>
                    <li v-if="isLogged && !isChild" class="setting">
                        <router-link to="/settings">{{ $t('menu.settings') }}</router-link>
                    </li>
                    <!--
                    <li v-if="!isLogged" class="pc">
                        <router-link to="/registration-new" class="icon"><register></register>{{ $t('auth.register') }}</router-link>
                    </li>
                    -->
                    <li v-if="!isLogged" class="pc">
                        <router-link to="/login" class="icon"><span></span>{{ $t('auth.login') }}</router-link>
                    </li>
                    <li v-else class="pc">
                        <router-link to="/" @click.native="handleOnClickLogout()" class="icon logout"><span></span>{{ $t('auth.logout') }}</router-link>
                    </li>

                    <li>
                        <language-choice :isFixed="isFixed"></language-choice>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="typeof $route.name !== 'undefined' && $route.name !== 'home'" class="nav pc">
            <ul>
                <li><router-link to="/">{{ $t('menu.home') }}</router-link></li>
                <template v-if="$i18n.locale === 'ja-JP' && $route.name === 'aubeCoinAutomaticRemittanceConfirm' && $route.meta.parent">
                    <li>
                        <span>></span>
                        <router-link :to="{ name: 'settings' }">{{ $t('menu.settings') }}</router-link>
                    </li>
                </template>
                <template v-else-if="$route.meta.parent">
                    <li v-for="(parent, index) in toArray($route.meta.parent)" :key="index">
                        <span>></span>
                        <router-link :to="{ name: $route.meta.breadcrumbLinkByMemberType ? breadcrumbLinkByMemberType(parent) : parent }">{{ $t('menu.' + breadcrumbLabel(parent)) }}</router-link>
                    </li>
                </template>
                <span>></span>
                <li>{{ $t('menu.'+ $route.name) }}</li>
            </ul>
        </div>

        <div class="sp">
            <div class="buttonWrapper">
                <language-choice isFixed></language-choice>
                <button type="button" :class="['btn', 'menu', {'top animate': isOpenMenu === true}]" @click="handleOnClickOpenMenu()">
                    <span></span>
                </button>
            </div>
        </div>
    </header>
</template>

<script>
import AuthUtil, {FORTHING_MEMBER_PARENT} from '../../utils/AuthUtil';
import LanguageChoice from '../LanguageChoice/LanguageChoice.vue';
import UserService from "../../services/UserService";
import MemberInfo from './MemberInfo.vue';
import { THEME_COLOR_HEADER_BY_ROUTE, MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD, MEMBER_TYPE_ID_ADVANCE, MEMBER_TYPE_ID_ADVANCE_CHILD } from '../../utils/Const';

    export default {
        name: 'app-header',

        data() {
            return {
                isFixed: false,
                isMobileMenu: false,
                isOpenMenu: false,
                isLogged: true,
                isChild: true,
                memberType: '',
                memberTypeId: '',
                forceClubId: '', // ForceClub ID
                questId: '----- ----- -----', // Quest ID
                aubeId: '-', // AUBE ID
                isLoading: true,
                themeTextHeder: null,
                isScrolled: false
            }
        },

        components: {
            LanguageChoice,
            MemberInfo
        },

        async created() {
            this.isLogged = AuthUtil.isAuth();

            if (this.isLogged) {
                this.fetchUserFrontendData();
            }
        },
        computed: {
            headerTextColor() {
                if (this.isScrolled) {
                    return null;
                }

                // MOBILE
                if (this.isMobileMenu) {
                    return THEME_COLOR_HEADER_BY_ROUTE.MOBILE_WHITE_COLOR.includes(this.$route.name)
                        ? '#fff'
                        : null;
                }

                // DESKTOP
                if (THEME_COLOR_HEADER_BY_ROUTE.DESKTOP_WHITE_COLOR.includes(this.$route.name) && !this.isFixed) {
                    return '#fff';
                }

                return null;
            }
        },

        methods: {
            async fetchUserFrontendData() {
                const data = (await UserService.getUserFrontendData()).data;
                this.isChild = data.is_child;
                this.memberTypeId = data.member_type_id;
                if (data.quest && data.quest.quest_id) {
                    this.questId = data.quest.quest_id;
                }
                // Get member type name
                this.memberType = await AuthUtil.getMemberTypeName(data.member_type_id);
                this.forceClubId = data.force_club_id ? data.force_club_id : '';
                this.questId = (data.quest && data.quest.quest_id) ? data.quest.quest_id : '----- ----- -----' ;
                this.aubeId = this.renderAUBEID(data.email);
                this.isLoading = false;
            },

            renderAUBEID(email) {
                const [name, domain] = email.split('@')
                const len = name.length

                if (len <= 4) {
                    return '*'.repeat(len) + '@' + domain
                }

                const first2 = name.slice(0, 2)
                const last2 = name.slice(-2)
                const maskedMiddle = '*'.repeat(len - 4)

                return `${first2}${maskedMiddle}${last2}@${domain}`
            },

            handleScroll() {
                const scrolled = window.scrollY > 10;
                this.isScrolled = scrolled;

                this.isFixed = this.isMobileMenu || window.scrollY > 10;

        		// $('header .right .user .text').removeClass('disabled');
        		// $('header .right .user .text').addClass('disabled');
	        },

            updateResize() {
                this.isMobileMenu = window.innerWidth <= 991;

                // $('header .right .user .text').removeClass('disabled');
                // $('header .right .user .text').addClass('disabled');
            },

            async handleOnClickLogout(e) {
                try {
                    await UserService.revokeToken(AuthUtil.getAuthToken());
                } catch (e) {}
                AuthUtil.clearAuth();
                this.isOpenMenu = false;
                this.$router.go('');
            },

            handleOnClickOpenMenu() {
                this.isOpenMenu = !this.isOpenMenu;
            },

            handleOnClickCloseMenu() {
                this.isOpenMenu = false;
            },

            isdeactivateCompleted(to) {
                return ( to.name === 'deactivateAdvanceComplete' || to.name === 'deactivateBasicComplete');
            },

            toArray(val) {
                return Array.isArray(val) ? val : [val];
            },

            breadcrumbLabel(key) {
                if (this.$route.meta.breadcrumbLabel && this.$route.meta.breadcrumbLabel[key]) {
                    return this.$route.meta.breadcrumbLabel[key];
                }

                return key;
            },

            breadcrumbLinkByMemberType(key) {
                if (!this.memberTypeId) {
                    return key;
                }

                const breadcrumbLink = this.$route.meta.breadcrumbLinkByMemberType;
                if (!breadcrumbLink) {
                    return key;
                }

                if (breadcrumbLink[key] && breadcrumbLink[key][this.memberTypeId]) {
                    if (this.memberTypeId === FORTHING_MEMBER_PARENT && this.questId) {
                        return key;
                    }

                    return breadcrumbLink[key][this.memberTypeId];
                }

                return key;
            },
            isBasicMember() {
                return ![MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD, MEMBER_TYPE_ID_ADVANCE, MEMBER_TYPE_ID_ADVANCE_CHILD].includes(this.memberTypeId)
            },

            isProgressMember() {
                return [MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD].includes(this.memberTypeId)
            },
            isAdvanceMember() {
                return [MEMBER_TYPE_ID_ADVANCE, MEMBER_TYPE_ID_ADVANCE_CHILD].includes(this.memberTypeId)
            }
        },

        watch: {
            $route (to, from){
                // 退会完了時にLogoutの表示をLoginに変更する
                // 退会完了時にAuthUtil.clearAuth()を呼び出してクッキーを削除しても
                // isLoggedは更新されない為
                if (this.isdeactivateCompleted(to)) {
                    this.isLogged = AuthUtil.isAuth();
                }
            }
        },

        mounted() {
            this.isLogged = AuthUtil.isAuth();
            this.isMobileMenu = window.innerWidth <= 991;

            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.updateResize);
        },

        destroy() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.updateResize);
        }
    }
</script>

<style scoped>
    .app-header .right>div>ul li a register {
        content: "";
        position: absolute;
        left: 0;
        top: 5px;
        background: url(./images/icon_register_black.svg) no-repeat;
        background-size: contain;
        width: 17px;
        height: 15px;
        display: inline-block;
        transition: all .5s ease-out;
    }

    .home .app-header .right div>ul li a register {
        background: url(./images/icon_register_white.svg) no-repeat;
        background-size: contain;
    }

    .app-header.fixed ul li a register {
        background: url(./images/icon_register_black.svg) no-repeat!important;
        background-size: contain!important;
    }
    .member-info-mobile {
        margin-top: 5px;
        background-color: #fbfbfb;
    }
</style>
